import { render, staticRenderFns } from "./shiftDialog.vue?vue&type=template&id=63123aa6&scoped=true"
import script from "./shiftDialog.vue?vue&type=script&lang=js"
export * from "./shiftDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63123aa6",
  null
  
)

export default component.exports